// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SectionFooter-module__font-s-10___aYGyM {
  font-size: 10px !important;
}

.SectionFooter-module__font-s-12___ME9LE {
  font-size: 12px !important;
}

.SectionFooter-module__font-s-13___PMewF {
  font-size: 13px !important;
}

.SectionFooter-module__font-s-14___BnT1W {
  font-size: 14px !important;
}

.SectionFooter-module__font-s-15___MAN5O {
  font-size: 15px !important;
}

.SectionFooter-module__font-s-16___jc0y7 {
  font-size: 16px !important;
}

.SectionFooter-module__font-s-18___yeGgs {
  font-size: 18px !important;
}

.SectionFooter-module__font-s-20___nVEQD {
  font-size: 20px !important;
}

.SectionFooter-module__font-s-22___F_wa7 {
  font-size: 22px !important;
}

.SectionFooter-module__font-s-28___mqyJo {
  font-size: 28px !important;
}

.SectionFooter-module__font-w-400___MTZuL {
  font-weight: 400 !important;
}

.SectionFooter-module__font-w-500___GsRCL {
  font-weight: 500 !important;
}

.SectionFooter-module__font-w-600___t1IZM {
  font-weight: 600 !important;
}

.SectionFooter-module__font-w-700___U7Am5 {
  font-weight: 700 !important;
}

.SectionFooter-module__p-5___Cyaba {
  padding: 5px !important;
}

.SectionFooter-module__p-12___BJ51W {
  padding: 12px !important;
}

.SectionFooter-module__p-16___Zxlvx {
  padding: 16px !important;
}

.SectionFooter-module__p-30___XC5pa {
  padding: 30px !important;
}

.SectionFooter-module__p-b-0___Odz55 {
  padding-bottom: 0 !important;
}

.SectionFooter-module__p-b-5___K4qxN {
  padding-bottom: 5px !important;
}

.SectionFooter-module__p-b-10___zpraL {
  padding-bottom: 10px !important;
}

.SectionFooter-module__p-b-12___PZK14 {
  padding-bottom: 12px !important;
}

.SectionFooter-module__p-b-16___oSgyu {
  padding-bottom: 16px !important;
}

.SectionFooter-module__p-b-18___nidVj {
  padding-bottom: 18px !important;
}

.SectionFooter-module__p-b-20___JXCYB {
  padding-bottom: 20px !important;
}

.SectionFooter-module__p-b-25___o4xkz {
  padding-bottom: 25px !important;
}

.SectionFooter-module__p-b-30___C3NbD {
  padding-bottom: 30px !important;
}

.SectionFooter-module__p-b-50___YkdIl {
  padding-bottom: 50px !important;
}

.SectionFooter-module__p-t-0___bhbVL {
  padding-top: 0 !important;
}

.SectionFooter-module__p-t-12___6y9Wh {
  padding-top: 12px !important;
}

.SectionFooter-module__p-t-16___AfCY8 {
  padding-top: 16px !important;
}

.SectionFooter-module__p-t-18___GCnAc {
  padding-top: 18px !important;
}

.SectionFooter-module__p-t-20___AJ9bV {
  padding-top: 20px !important;
}

.SectionFooter-module__p-t-30___Q_ssN {
  padding-top: 30px !important;
}

.SectionFooter-module__p-t-40___VhSfx {
  padding-top: 40px !important;
}

.SectionFooter-module__p-t-50___Cgtfu {
  padding-top: 50px !important;
}

.SectionFooter-module__p-l-20___inEjn {
  padding-left: 20px !important;
}

.SectionFooter-module__p-l-30___HfuKE {
  padding-left: 30px !important;
}

.SectionFooter-module__p-l-40___nbFMy {
  padding-left: 40px !important;
}

.SectionFooter-module__p-r-16___QxZUn {
  padding-right: 16px !important;
}

.SectionFooter-module__p-r-20___t_NbS {
  padding-right: 20px !important;
}

.SectionFooter-module__p-r-30___kDzVv {
  padding-right: 30px !important;
}

.SectionFooter-module__p-r-50___F_oC6 {
  padding-right: 50px !important;
}

.SectionFooter-module__p-r-60___mqsSD {
  padding-right: 60px !important;
}

.SectionFooter-module__m-b-1___Fr12d {
  margin-bottom: 1px !important;
}

.SectionFooter-module__m-b-2___TqkAA {
  margin-bottom: 2px !important;
}

.SectionFooter-module__m-b-6___ydMcQ {
  margin-bottom: 6px !important;
}

.SectionFooter-module__m-b-8___fbAPr {
  margin-bottom: 8px !important;
}

.SectionFooter-module__m-b-10___piHna {
  margin-bottom: 10px !important;
}

.SectionFooter-module__m-b-14___fjGfw {
  margin-bottom: 14px !important;
}

.SectionFooter-module__m-b-16___qcej0 {
  margin-bottom: 16px !important;
}

.SectionFooter-module__m-b-20___zFk67 {
  margin-bottom: 20px !important;
}

.SectionFooter-module__m-b-22___Ifmny {
  margin-bottom: 22px !important;
}

.SectionFooter-module__m-b-24___JdSdd {
  margin-bottom: 24px !important;
}

.SectionFooter-module__m-b-30___Eopen {
  margin-bottom: 30px !important;
}

.SectionFooter-module__m-b-32___Gbimw {
  margin-bottom: 32px !important;
}

.SectionFooter-module__m-b-40___NHmW3 {
  margin-bottom: 40px !important;
}

.SectionFooter-module__m-t-2___R6Tb1 {
  margin-top: 2px !important;
}

.SectionFooter-module__m-t-3___MAC_M {
  margin-top: 3px !important;
}

.SectionFooter-module__m-t-4___bBTKv {
  margin-top: 4px !important;
}

.SectionFooter-module__m-t-5___KAk88 {
  margin-top: 5px !important;
}

.SectionFooter-module__m-t-8___aBrw2 {
  margin-top: 8px !important;
}

.SectionFooter-module__m-t-10___eoTBj {
  margin-top: 10px !important;
}

.SectionFooter-module__m-t-15___QXPiO {
  margin-top: 15px !important;
}

.SectionFooter-module__m-t-16___Wkepy {
  margin-top: 16px !important;
}

.SectionFooter-module__m-t-20___dRrx7 {
  margin-top: 20px !important;
}

.SectionFooter-module__m-t-22___ge6ol {
  margin-top: 22px !important;
}

.SectionFooter-module__m-t-30___Xunjw {
  margin-top: 30px !important;
}

.SectionFooter-module__m-t-32___ulBPi {
  margin-top: 32px !important;
}

.SectionFooter-module__m-l-auto___pyiL0 {
  margin-left: auto !important;
}

.SectionFooter-module__m-l-4___pzeyi {
  margin-left: 4px !important;
}

.SectionFooter-module__m-l-5___ETvnM {
  margin-left: 5px !important;
}

.SectionFooter-module__m-l-6___S1hy7 {
  margin-left: 6px !important;
}

.SectionFooter-module__m-l-8___lflud {
  margin-left: 8px !important;
}

.SectionFooter-module__m-l-10___I0is5 {
  margin-left: 10px !important;
}

.SectionFooter-module__m-l-16___OLiyd {
  margin-left: 16px !important;
}

.SectionFooter-module__m-l-20___A8PkA {
  margin-left: 20px !important;
}

.SectionFooter-module__m-l-24___pZTIH {
  margin-left: 24px !important;
}

.SectionFooter-module__m-l-30___AbxWV {
  margin-left: 30px !important;
}

.SectionFooter-module__m-l-35___Yfl6a {
  margin-left: 35px !important;
}

.SectionFooter-module__m-l-40___NA4JB {
  margin-left: 40px !important;
}

.SectionFooter-module__m-r-8___mgyjB {
  margin-right: 8px !important;
}

.SectionFooter-module__m-r-10___nABdB {
  margin-right: 10px !important;
}

.SectionFooter-module__m-r-16___dga0h {
  margin-right: 16px !important;
}

.SectionFooter-module__m-r-20___bfCVG {
  margin-right: 20px !important;
}

.SectionFooter-module__m-r-24___f8EyX {
  margin-right: 24px !important;
}

.SectionFooter-module__m-r-30___cF5Id {
  margin-right: 30px !important;
}

.SectionFooter-module__m-r-40___Fi6oG {
  margin-right: 40px !important;
}

.SectionFooter-module__border-r-3___ZUC17 {
  border-radius: 3px !important;
}

.SectionFooter-module__border-r-4___eN_z5 {
  border-radius: 4px !important;
}

.SectionFooter-module__border-r-6___SBswD {
  border-radius: 6px !important;
}

.SectionFooter-module__border-r-10___oLPo4 {
  border-radius: 10px !important;
}

.SectionFooter-module__border-r-12___ztDHQ {
  border-radius: 12px !important;
}

.SectionFooter-module__border-r-16___Pcm6w {
  border-radius: 16px !important;
}

.SectionFooter-module__border-r-50___cUTae {
  border-radius: 50% !important;
}

.SectionFooter-module__primary-border___H464K {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionFooter-module__primary-border-b___kejou {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionFooter-module__primary-border-t___Kx4hF {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionFooter-module__primary-border-l___i3Mvw {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionFooter-module__primary-border-r___ylZ8S {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.SectionFooter-module__secondary-border____dS12 {
  border: 1px solid #637768;
}

.SectionFooter-module__secondary-border-b___JNX4E {
  border-bottom: 1px solid #637768;
}

.SectionFooter-module__secondary-border-t___tzNXU {
  border-top: 1px solid #637768;
}

.SectionFooter-module__secondary-border-l___RDZfN {
  border-left: 1px solid #637768;
}

.SectionFooter-module__secondary-border-r___gCN2y {
  border-right: 1px solid #637768;
}

.SectionFooter-module__gap-0___T6enR {
  gap: 0 !important;
}

.SectionFooter-module__gap-2___aGi9R {
  gap: 2px !important;
}

.SectionFooter-module__gap-4___RVlk4 {
  gap: 4px !important;
}

.SectionFooter-module__gap-5___Vxkqp {
  gap: 5px !important;
}

.SectionFooter-module__gap-6___ZG5Cg {
  gap: 6px !important;
}

.SectionFooter-module__gap-8___nVe3f {
  gap: 8px !important;
}

.SectionFooter-module__gap-10___E7iKz {
  gap: 10px !important;
}

.SectionFooter-module__gap-12___E5gfT {
  gap: 12px !important;
}

.SectionFooter-module__gap-14___wZcOt {
  gap: 14px !important;
}

.SectionFooter-module__gap-16___xPOXE {
  gap: 16px !important;
}

.SectionFooter-module__gap-18___HETKi {
  gap: 18px !important;
}

.SectionFooter-module__gap-20___cPbED {
  gap: 20px !important;
}

.SectionFooter-module__gap-24___aiqsS {
  gap: 24px !important;
}

.SectionFooter-module__gap-26___L6fu6 {
  gap: 26px !important;
}

.SectionFooter-module__gap-30___w45OF {
  gap: 30px !important;
}

.SectionFooter-module__gap-32___YFGxD {
  gap: 32px !important;
}

.SectionFooter-module__gap-40___Acj54 {
  gap: 40px !important;
}

.SectionFooter-module__gap-50___TgRym {
  gap: 50px !important;
}

.SectionFooter-module__flex-1___lRCbY {
  flex: 1;
}

.SectionFooter-module__flex-none___LESzX {
  flex: none !important;
}

.SectionFooter-module__flex-column___zmhuN {
  display: flex;
  flex-direction: column !important;
}

.SectionFooter-module__flex-row___Ok2O9 {
  display: flex;
  flex-direction: row !important;
}

.SectionFooter-module__vertically-centered___bgDtx {
  display: flex;
  align-items: center !important;
}

.SectionFooter-module__horizontally-centered___rFHyb {
  display: flex;
  justify-content: center !important;
}

.SectionFooter-module__horizontally-end___fM3zs {
  display: flex;
  justify-content: end !important;
}

.SectionFooter-module__vertically-start___vDy8n {
  display: flex;
  align-items: start !important;
}

.SectionFooter-module__space-between___Y9htx {
  display: flex;
  justify-content: space-between !important;
}

.SectionFooter-module__flex-wrap___TeCni {
  flex-wrap: wrap !important;
}

.SectionFooter-module__height-100___zXJ9V {
  height: 100%;
}

.SectionFooter-module__width-50___tzJQy {
  width: 50% !important;
}

.SectionFooter-module__width-100___i8MR7 {
  width: 100%;
}

.SectionFooter-module__cursor-pointer___3DjWK {
  cursor: pointer;
}

.SectionFooter-module__cursor-not-allowed___y5cwf {
  cursor: not-allowed !important;
}

.SectionFooter-module__absolute-centered___EnteS {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.SectionFooter-module__absolute___XWfCS {
  position: absolute;
}

.SectionFooter-module__relative___pdwky {
  position: relative;
}

.SectionFooter-module__fixed___ldbpR {
  position: fixed;
}

.SectionFooter-module__visible___YhYBV {
  opacity: 1;
}

.SectionFooter-module__invisible___UuhnG {
  opacity: 0;
}

.SectionFooter-module__col-90___w8B2_ {
  width: 90% !important;
}

.SectionFooter-module__col-auto___rr_OQ {
  width: auto !important;
}

.SectionFooter-module__medical-tabs___L3YtM {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.SectionFooter-module__medical-table-new___QvMH5 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SectionFooter-module__medical-table-new___QvMH5:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SectionFooter-module__medical-table-new___QvMH5::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SectionFooter-module__medical-table-new___QvMH5::-webkit-scrollbar-track {
  display: none;
}
.SectionFooter-module__medical-table-new___QvMH5.SectionFooter-module__no-pagination___h3M22 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.SectionFooter-module__medical-table-new___QvMH5.SectionFooter-module__no-pagination___h3M22:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.SectionFooter-module__medical-table-new___QvMH5.SectionFooter-module__no-pagination___h3M22::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.SectionFooter-module__medical-table-new___QvMH5.SectionFooter-module__no-pagination___h3M22::-webkit-scrollbar-track {
  display: none;
}

.SectionFooter-module__medical-table-empty___rmmKP {
  padding: 14px 40px !important;
}

.SectionFooter-module__icon-btn___q3OtN {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.SectionFooter-module__search-icon___JlzIx {
  width: 24px;
  height: 24px;
  align-self: center;
}

.SectionFooter-module__disable-select___Ne9LC {
  user-select: none;
}

.SectionFooter-module__break-word___KJ1XD {
  word-break: break-word;
}

.SectionFooter-module__popup-clear-btn___l1oxJ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.SectionFooter-module__scroll-m-b-20___CEDB0 {
  scroll-margin-bottom: 20px;
}

.SectionFooter-module__footer___WGlmO {
  justify-content: flex-end;
  padding: 17px 35px;
}
.SectionFooter-module__footer___WGlmO.SectionFooter-module__embedded___FpRcT {
  padding: 0;
  margin-right: 25px;
  height: 100%;
}
.SectionFooter-module__footer___WGlmO .SectionFooter-module__icon___R0gJz {
  filter: invert(77%) sepia(5%) saturate(0%) hue-rotate(228deg) brightness(87%) contrast(79%);
}
.SectionFooter-module__footer___WGlmO .SectionFooter-module__deleteBtn___HvWqf {
  border-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/components/SectionFooter/SectionFooter.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,UAAA;EACA,kBAAA;EACA,YAAA;AA8pBJ;AA3pBE;EACE,2FAAA;AA6pBJ;AA1pBE;EACE,oCAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.footer {\n  justify-content: flex-end;\n  padding: 17px 35px;\n\n  &.embedded {\n    padding: 0;\n    margin-right: 25px;\n    height: 100%;\n  }\n\n  .icon {\n    filter: invert(77%) sepia(5%) saturate(0%) hue-rotate(228deg) brightness(87%) contrast(79%);\n  }\n\n  .deleteBtn {\n    border-color: transparent !important;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `SectionFooter-module__font-s-10___aYGyM`,
	"fontS12": `SectionFooter-module__font-s-12___ME9LE`,
	"fontS13": `SectionFooter-module__font-s-13___PMewF`,
	"fontS14": `SectionFooter-module__font-s-14___BnT1W`,
	"fontS15": `SectionFooter-module__font-s-15___MAN5O`,
	"fontS16": `SectionFooter-module__font-s-16___jc0y7`,
	"fontS18": `SectionFooter-module__font-s-18___yeGgs`,
	"fontS20": `SectionFooter-module__font-s-20___nVEQD`,
	"fontS22": `SectionFooter-module__font-s-22___F_wa7`,
	"fontS28": `SectionFooter-module__font-s-28___mqyJo`,
	"fontW400": `SectionFooter-module__font-w-400___MTZuL`,
	"fontW500": `SectionFooter-module__font-w-500___GsRCL`,
	"fontW600": `SectionFooter-module__font-w-600___t1IZM`,
	"fontW700": `SectionFooter-module__font-w-700___U7Am5`,
	"p5": `SectionFooter-module__p-5___Cyaba`,
	"p12": `SectionFooter-module__p-12___BJ51W`,
	"p16": `SectionFooter-module__p-16___Zxlvx`,
	"p30": `SectionFooter-module__p-30___XC5pa`,
	"pB0": `SectionFooter-module__p-b-0___Odz55`,
	"pB5": `SectionFooter-module__p-b-5___K4qxN`,
	"pB10": `SectionFooter-module__p-b-10___zpraL`,
	"pB12": `SectionFooter-module__p-b-12___PZK14`,
	"pB16": `SectionFooter-module__p-b-16___oSgyu`,
	"pB18": `SectionFooter-module__p-b-18___nidVj`,
	"pB20": `SectionFooter-module__p-b-20___JXCYB`,
	"pB25": `SectionFooter-module__p-b-25___o4xkz`,
	"pB30": `SectionFooter-module__p-b-30___C3NbD`,
	"pB50": `SectionFooter-module__p-b-50___YkdIl`,
	"pT0": `SectionFooter-module__p-t-0___bhbVL`,
	"pT12": `SectionFooter-module__p-t-12___6y9Wh`,
	"pT16": `SectionFooter-module__p-t-16___AfCY8`,
	"pT18": `SectionFooter-module__p-t-18___GCnAc`,
	"pT20": `SectionFooter-module__p-t-20___AJ9bV`,
	"pT30": `SectionFooter-module__p-t-30___Q_ssN`,
	"pT40": `SectionFooter-module__p-t-40___VhSfx`,
	"pT50": `SectionFooter-module__p-t-50___Cgtfu`,
	"pL20": `SectionFooter-module__p-l-20___inEjn`,
	"pL30": `SectionFooter-module__p-l-30___HfuKE`,
	"pL40": `SectionFooter-module__p-l-40___nbFMy`,
	"pR16": `SectionFooter-module__p-r-16___QxZUn`,
	"pR20": `SectionFooter-module__p-r-20___t_NbS`,
	"pR30": `SectionFooter-module__p-r-30___kDzVv`,
	"pR50": `SectionFooter-module__p-r-50___F_oC6`,
	"pR60": `SectionFooter-module__p-r-60___mqsSD`,
	"mB1": `SectionFooter-module__m-b-1___Fr12d`,
	"mB2": `SectionFooter-module__m-b-2___TqkAA`,
	"mB6": `SectionFooter-module__m-b-6___ydMcQ`,
	"mB8": `SectionFooter-module__m-b-8___fbAPr`,
	"mB10": `SectionFooter-module__m-b-10___piHna`,
	"mB14": `SectionFooter-module__m-b-14___fjGfw`,
	"mB16": `SectionFooter-module__m-b-16___qcej0`,
	"mB20": `SectionFooter-module__m-b-20___zFk67`,
	"mB22": `SectionFooter-module__m-b-22___Ifmny`,
	"mB24": `SectionFooter-module__m-b-24___JdSdd`,
	"mB30": `SectionFooter-module__m-b-30___Eopen`,
	"mB32": `SectionFooter-module__m-b-32___Gbimw`,
	"mB40": `SectionFooter-module__m-b-40___NHmW3`,
	"mT2": `SectionFooter-module__m-t-2___R6Tb1`,
	"mT3": `SectionFooter-module__m-t-3___MAC_M`,
	"mT4": `SectionFooter-module__m-t-4___bBTKv`,
	"mT5": `SectionFooter-module__m-t-5___KAk88`,
	"mT8": `SectionFooter-module__m-t-8___aBrw2`,
	"mT10": `SectionFooter-module__m-t-10___eoTBj`,
	"mT15": `SectionFooter-module__m-t-15___QXPiO`,
	"mT16": `SectionFooter-module__m-t-16___Wkepy`,
	"mT20": `SectionFooter-module__m-t-20___dRrx7`,
	"mT22": `SectionFooter-module__m-t-22___ge6ol`,
	"mT30": `SectionFooter-module__m-t-30___Xunjw`,
	"mT32": `SectionFooter-module__m-t-32___ulBPi`,
	"mLAuto": `SectionFooter-module__m-l-auto___pyiL0`,
	"mL4": `SectionFooter-module__m-l-4___pzeyi`,
	"mL5": `SectionFooter-module__m-l-5___ETvnM`,
	"mL6": `SectionFooter-module__m-l-6___S1hy7`,
	"mL8": `SectionFooter-module__m-l-8___lflud`,
	"mL10": `SectionFooter-module__m-l-10___I0is5`,
	"mL16": `SectionFooter-module__m-l-16___OLiyd`,
	"mL20": `SectionFooter-module__m-l-20___A8PkA`,
	"mL24": `SectionFooter-module__m-l-24___pZTIH`,
	"mL30": `SectionFooter-module__m-l-30___AbxWV`,
	"mL35": `SectionFooter-module__m-l-35___Yfl6a`,
	"mL40": `SectionFooter-module__m-l-40___NA4JB`,
	"mR8": `SectionFooter-module__m-r-8___mgyjB`,
	"mR10": `SectionFooter-module__m-r-10___nABdB`,
	"mR16": `SectionFooter-module__m-r-16___dga0h`,
	"mR20": `SectionFooter-module__m-r-20___bfCVG`,
	"mR24": `SectionFooter-module__m-r-24___f8EyX`,
	"mR30": `SectionFooter-module__m-r-30___cF5Id`,
	"mR40": `SectionFooter-module__m-r-40___Fi6oG`,
	"borderR3": `SectionFooter-module__border-r-3___ZUC17`,
	"borderR4": `SectionFooter-module__border-r-4___eN_z5`,
	"borderR6": `SectionFooter-module__border-r-6___SBswD`,
	"borderR10": `SectionFooter-module__border-r-10___oLPo4`,
	"borderR12": `SectionFooter-module__border-r-12___ztDHQ`,
	"borderR16": `SectionFooter-module__border-r-16___Pcm6w`,
	"borderR50": `SectionFooter-module__border-r-50___cUTae`,
	"primaryBorder": `SectionFooter-module__primary-border___H464K`,
	"primaryBorderB": `SectionFooter-module__primary-border-b___kejou`,
	"primaryBorderT": `SectionFooter-module__primary-border-t___Kx4hF`,
	"primaryBorderL": `SectionFooter-module__primary-border-l___i3Mvw`,
	"primaryBorderR": `SectionFooter-module__primary-border-r___ylZ8S`,
	"secondaryBorder": `SectionFooter-module__secondary-border____dS12`,
	"secondaryBorderB": `SectionFooter-module__secondary-border-b___JNX4E`,
	"secondaryBorderT": `SectionFooter-module__secondary-border-t___tzNXU`,
	"secondaryBorderL": `SectionFooter-module__secondary-border-l___RDZfN`,
	"secondaryBorderR": `SectionFooter-module__secondary-border-r___gCN2y`,
	"gap0": `SectionFooter-module__gap-0___T6enR`,
	"gap2": `SectionFooter-module__gap-2___aGi9R`,
	"gap4": `SectionFooter-module__gap-4___RVlk4`,
	"gap5": `SectionFooter-module__gap-5___Vxkqp`,
	"gap6": `SectionFooter-module__gap-6___ZG5Cg`,
	"gap8": `SectionFooter-module__gap-8___nVe3f`,
	"gap10": `SectionFooter-module__gap-10___E7iKz`,
	"gap12": `SectionFooter-module__gap-12___E5gfT`,
	"gap14": `SectionFooter-module__gap-14___wZcOt`,
	"gap16": `SectionFooter-module__gap-16___xPOXE`,
	"gap18": `SectionFooter-module__gap-18___HETKi`,
	"gap20": `SectionFooter-module__gap-20___cPbED`,
	"gap24": `SectionFooter-module__gap-24___aiqsS`,
	"gap26": `SectionFooter-module__gap-26___L6fu6`,
	"gap30": `SectionFooter-module__gap-30___w45OF`,
	"gap32": `SectionFooter-module__gap-32___YFGxD`,
	"gap40": `SectionFooter-module__gap-40___Acj54`,
	"gap50": `SectionFooter-module__gap-50___TgRym`,
	"flex1": `SectionFooter-module__flex-1___lRCbY`,
	"flexNone": `SectionFooter-module__flex-none___LESzX`,
	"flexColumn": `SectionFooter-module__flex-column___zmhuN`,
	"flexRow": `SectionFooter-module__flex-row___Ok2O9`,
	"verticallyCentered": `SectionFooter-module__vertically-centered___bgDtx`,
	"horizontallyCentered": `SectionFooter-module__horizontally-centered___rFHyb`,
	"horizontallyEnd": `SectionFooter-module__horizontally-end___fM3zs`,
	"verticallyStart": `SectionFooter-module__vertically-start___vDy8n`,
	"spaceBetween": `SectionFooter-module__space-between___Y9htx`,
	"flexWrap": `SectionFooter-module__flex-wrap___TeCni`,
	"height100": `SectionFooter-module__height-100___zXJ9V`,
	"width50": `SectionFooter-module__width-50___tzJQy`,
	"width100": `SectionFooter-module__width-100___i8MR7`,
	"cursorPointer": `SectionFooter-module__cursor-pointer___3DjWK`,
	"cursorNotAllowed": `SectionFooter-module__cursor-not-allowed___y5cwf`,
	"absoluteCentered": `SectionFooter-module__absolute-centered___EnteS`,
	"absolute": `SectionFooter-module__absolute___XWfCS`,
	"relative": `SectionFooter-module__relative___pdwky`,
	"fixed": `SectionFooter-module__fixed___ldbpR`,
	"visible": `SectionFooter-module__visible___YhYBV`,
	"invisible": `SectionFooter-module__invisible___UuhnG`,
	"col90": `SectionFooter-module__col-90___w8B2_`,
	"colAuto": `SectionFooter-module__col-auto___rr_OQ`,
	"medicalTabs": `SectionFooter-module__medical-tabs___L3YtM`,
	"medicalTableNew": `SectionFooter-module__medical-table-new___QvMH5`,
	"noPagination": `SectionFooter-module__no-pagination___h3M22`,
	"medicalTableEmpty": `SectionFooter-module__medical-table-empty___rmmKP`,
	"iconBtn": `SectionFooter-module__icon-btn___q3OtN`,
	"searchIcon": `SectionFooter-module__search-icon___JlzIx`,
	"disableSelect": `SectionFooter-module__disable-select___Ne9LC`,
	"breakWord": `SectionFooter-module__break-word___KJ1XD`,
	"popupClearBtn": `SectionFooter-module__popup-clear-btn___l1oxJ`,
	"scrollMB20": `SectionFooter-module__scroll-m-b-20___CEDB0`,
	"footer": `SectionFooter-module__footer___WGlmO`,
	"embedded": `SectionFooter-module__embedded___FpRcT`,
	"icon": `SectionFooter-module__icon___R0gJz`,
	"deleteBtn": `SectionFooter-module__deleteBtn___HvWqf`
};
module.exports = ___CSS_LOADER_EXPORT___;
